import React from "react";
import { useWizardContextState } from "../../context/wizardContext";
import DiscomfortScale from "./WizardComponents/discomfortScale";
import styles from "./checkBraSupport.module.css";

export const CheckBraSupport = (props) => {
  const { cup, selectedCropTopSize } = useWizardContextState();
  const { breastSupportRecommended } = props;

  let videoSrcAcceptable = "";
  let videoSrcExcessive = "";
  let videoPosterAcceptable = "";
  let videoPosterExcessive = "";
  let acceptableMovement = "";
  let excessiveMovement = "";

  if (
    breastSupportRecommended[0].name ===
    "Encapsulation Sports Bra AND Crop Top Sports Bra"
  ) {
    videoSrcAcceptable = require(`../../assets/video/LargeSBCTAcceptableMovementEdited.mp4`);
    videoSrcExcessive = require(`../../assets/video/LargeSBCTExcessiveMovementEdited.mp4`);
    videoPosterAcceptable = require("../../assets/video/LargeSBCTAcceptableMovementEdited.png");
    videoPosterExcessive = require("../../assets/video/LargeSBCTExcessiveMovementEdited.png");
    acceptableMovement = "4";
    excessiveMovement = "8-9";
  } else if (breastSupportRecommended[0].name.includes("Crop")) {
    videoSrcAcceptable = require(`../../assets/video/SmallCTAcceptableMovementEdited.mp4`);
    videoSrcExcessive = require(`../../assets/video/SmallCTExcessiveMovementEdited.mp4`);
    videoPosterAcceptable = require("../../assets/video/SmallCTAcceptableMovementEdited.png");
    videoPosterExcessive = require("../../assets/video/SmallCTExcessiveMovementEdited.png");
    acceptableMovement = "3-4";
    excessiveMovement = "5-6";
  } else if (breastSupportRecommended[0].name.includes("Encapsulation")) {
    if (cup < "C" || ["XS", "S", "M"].includes(selectedCropTopSize)) {
      videoSrcAcceptable = require(`../../assets/video/SmallSBAcceptableMovementEdited.mp4`);
      videoSrcExcessive = require(`../../assets/video/SmallSBExcessiveMovementEdited.mp4`);
      videoPosterAcceptable = require("../../assets/video/SmallSBAcceptableMovementEdited.png");
      videoPosterExcessive = require("../../assets/video/SmallSBExcessiveMovementEdited.png");
      acceptableMovement = "3-4";
      excessiveMovement = "5-6";
    } else {
      videoSrcAcceptable = require(`../../assets/video/MediumSBAcceptableMovementEdited.mp4`);
      videoSrcExcessive = require(`../../assets/video/MediumSBExcessiveMovementEdited.mp4`);
      videoPosterAcceptable = require("../../assets/video/MediumSBAcceptableMovementEdited.png");
      videoPosterExcessive = require("../../assets/video/MediumSBExcessiveMovementEdited.png");
      acceptableMovement = "3-4";
      excessiveMovement = "5-6";
    }
  }

  return (
    <div className={styles.checkSupportContainer}>
      {/* Step 1 – Instructions */}
      <div className={`${styles.supportiveBraInfo} ${styles.stepOneContent}`}>
        <p>
          <strong>
            1. Observe your breast movement in a mirror as you run on the spot
            or jump up and down and pay attention to how your breasts feel.
          </strong>
        </p>
        <img
          className={styles.stepImage}
          src={require(`../../assets/step1-bra-support.png`).default}
          alt="Illustration of person running on a treadmill in front of a mirror"
        />
      </div>

      {/* Step 2 – Instructions */}
      <div className={styles.supportiveBraInfo}>
        <p>
          <strong>2. Use the scales below to rank your:</strong>
        </p>
        <ul>
          <li>
            <strong>Breast discomfort</strong>: where 0 = no discomfort and 10 =
            extreme discomfort. <br />
            <em>It should be 0.</em>
          </li>
          <li>
            <strong>Breast movement</strong>: where 0 = no breast movement and
            10 = the breast movement that would occur if you were running bare
            breasted. <br />
            <em>It should be 3–4.</em>
          </li>
        </ul>
      </div>

      {/* Step 2 – Scales */}
      <div className={styles.scaleContainer}>
        <DiscomfortScale
          scaleTitle={"Breast Discomfort"}
          scaleZero={"No discomfort"}
          scaleTen={"Extreme discomfort"}
        />
        <DiscomfortScale
          scaleTitle={"Breast Movement"}
          scaleZero={"No movement"}
          scaleTen={"Running bare breasted"}
        />
      </div>

      {/* Step 3 – Outcome */}
      <div className={styles.supportiveBraInfo}>
        <p>
          <strong>Outcome:</strong>
        </p>
        <p>Your sports bra provides good support if…</p>
        <ul>
          <li>
            <strong>Breast discomfort = 0</strong>
          </li>
          <li>
            <strong>Breast movement = 3–4</strong>
          </li>
        </ul>
        <p>You need to buy a new sports bra if…</p>
        <ul>
          <li>
            <strong>Breast discomfort &gt; 0</strong>
          </li>
          <li>
            <strong>Breast movement &gt; 4</strong>
          </li>
        </ul>
      </div>

      {/* Videos (Step 4) */}
      <div className={styles.videoContainer}>
        <div className={styles.videoItem}>
          <h2 className={styles.movement}>
            Acceptable Movement {acceptableMovement}
          </h2>
          <video
            poster={videoPosterAcceptable.default}
            id="acceptableMovement"
            width="100%"
            height="100%"
            preload="metadata"
            controls
            playsInline
            autoPlay
            loop
            muted
          >
            <source src={videoSrcAcceptable.default} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
        <div className={styles.videoItem}>
          <h2 className={styles.movement}>
            Excessive Movement {excessiveMovement}
          </h2>
          <video
            poster={videoPosterExcessive.default}
            id="excessiveMovement"
            width="100%"
            height="100%"
            preload="metadata"
            controls
            playsInline
            autoPlay
            loop
            muted
          >
            <source src={videoSrcExcessive.default} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </div>
  );
};

export default CheckBraSupport;
